import { inputToTags, tagsToInput } from "../../mst/kinds/utils";
import { getDefaultBaseInput, OptimisticConcurrency } from "../../schema/types/base";
import { IpSetCreate } from "../../schema/types/ipset/create";
import { IpSet } from "../../schema/types/ipset/entity";
import { IpSetInput } from "../../schema/types/ipset/input";
import { parseLink } from "../../utils/linkParser/linkParser";
import { v4 as uuidv4 } from "uuid";

export function getDefaultIpSetInput(): IpSetInput {
  return {
    ...getDefaultBaseInput(),
    version: 0,
    id: "",
    gvc: {
      value: "",
      link: "",
    },
    workload: {
      value: "",
      link: "",
    },
    target: "gvc",
    locations: [],
    meta: {
      isEdit: false,
    },
  };
}

export function inputToIpSet(input: IpSetInput): IpSetCreate {
  const res: IpSetCreate = {
    name: input.name,
    kind: "ipset",
    spec: {},
    tags: inputToTags(input.tags),
  };
  if (input.description) {
    res.description = input.description;
  }

  if (input.target === "gvc" && input.gvc.link) {
    res.spec.link = input.gvc.link;
  }
  if (input.target === "workload" && input.workload.link) {
    res.spec.link = input.workload.link;
  }

  res.spec.locations = input.locations.map((l) => ({ name: l.location.link, retentionPolicy: l.retentionPolicy }));

  return res;
}

export function ipSetToInput(ipSet: IpSet): IpSetInput {
  const def = getDefaultIpSetInput();
  const res: IpSetInput = {
    ...def,
    version: ipSet.version,
    id: ipSet.id,
    name: ipSet.name,
    description: ipSet.description,
    tags: tagsToInput(ipSet.tags),
    meta: {
      ...def.meta,
      isEdit: true,
    },
  };

  if (ipSet.spec.link) {
    const { kind, name, absolute, gvcRelative } = parseLink(ipSet.spec.link, { useInputCtx: true });
    if (kind === "gvc") {
      res.target = "gvc";
      res.gvc.value = name;
      res.gvc.link = absolute;
    }
    if (kind === "workload") {
      res.target = "workload";
      res.workload.value = gvcRelative;
      res.workload.link = absolute;
    }
  }

  if (ipSet.spec.locations) {
    res.locations = ipSet.spec.locations.map((l) => {
      const { name, absolute } = parseLink(l.name, { useInputCtx: true });
      return {
        id: uuidv4(),
        location: {
          value: name,
          name: name,
          link: absolute,
        },
        retentionPolicy: l.retentionPolicy,
      };
    });
  }

  return res;
}

export function ipSetToPatch(_ipSet: IpSetCreate, concurrency: OptimisticConcurrency) {
  const ipSet: any = JSON.parse(JSON.stringify(_ipSet));

  ipSet[`$replace/spec`] = ipSet.spec;
  delete ipSet.spec;

  ipSet[`$replace/tags`] = ipSet.tags;
  delete ipSet.tags;

  ipSet.id = concurrency.id;
  ipSet.version = concurrency.version;

  return ipSet;
}
